const demo_app = {
    notification: '提示：先註冊一個帳號，再測試登錄體驗。',
};
export default demo_app;
